import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=e5c2bab2&"
import script from "./assign.vue?vue&type=script&lang=js&"
export * from "./assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5c2bab2')) {
      api.createRecord('e5c2bab2', component.options)
    } else {
      api.reload('e5c2bab2', component.options)
    }
    module.hot.accept("./assign.vue?vue&type=template&id=e5c2bab2&", function () {
      api.rerender('e5c2bab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/permission/assign.vue"
export default component.exports